export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export interface IEnvironment {
  production: boolean;
  environment: string;

  // Enables use of ng.profiler.timeChangeDetection(); in browser console
  enableDebugTools: boolean;
  logLevel: LogLevel;
  apiInfo: ApiInfo;
  clientRoot: string;
  companyLogoUrl: string;
  branchLogoUrl: string;
  dnsBasedBranchLogoUrl: string;
  faviconUrl: string;
  borrowerPortalLoginImageUrl: string;
  borrowerPortalURI: string;
  scope?: string;
  eSignSSORedirectUrl?: string;

  // Static, deployment-wide page the signing vendors that pin their redirect at order-creation time are sent
  // back to, for the portal this build serves - the api is configured with the same host per portal, since the
  // signer's company portal domain is not known when the order is created. Only its origin is read.
  eSignVendorRedirectUrl?: string;

  // Build version - replaced by CI/CD pipeline at build time
  version: string;
}

export class ApiInfo {
  apiBaseUrl: string | undefined;
  publicApiBaseUrl: string | undefined;
  docApiBaseUrl: string | undefined;
  authApiBaseUrl: string | undefined;
}
